export default {
    computed: {
        hasRemoteId() {
            return !Vue.dingIsLocalId(this.block.id);
        }
    },
    methods: {
        createEmptyLocalContentUnit() {
            return {
                id: Vue.dingGenerateLocalId(),
                fileObject: null,
                file_name: null,
                text: null
            };
        }
    }
}
